import { render, staticRenderFns } from "./AttributesContext.vue?vue&type=template&id=1479b8cf&scoped=true"
import script from "./AttributesContext.vue?vue&type=script&lang=js"
export * from "./AttributesContext.vue?vue&type=script&lang=js"
import style0 from "./AttributesContext.vue?vue&type=style&index=0&id=1479b8cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1479b8cf",
  null
  
)

export default component.exports